import React, { useState } from "react";
import "./postCardList.scss";
import PostCardVertical from "../postCard/postCardVertical";

const PostCardList = ({
  posts,
  showMoreVisibility,
  showMoreCount,
}) => {
  const [loadMorePost, setLoadMorePost] = useState(1);

  const showPosts = showMoreCount
    ? showMoreCount
    : posts?.length;

  return (
    <>
      <ul className="post-card-list">
        {posts
          .slice(
            0,
            Math.min(showPosts * loadMorePost, posts.length)
          )
          .map(post => {
            return (
              <li
                key={post.uri}
                className="post-card-list-item"
              >
                <PostCardVertical post={post} />
              </li>
            );
          })}
      </ul>
      {showMoreVisibility &&
        posts?.length > showPosts &&
        Math.min(showPosts * loadMorePost, posts.length) <
          posts.length && (
          <div className="load-more-button">
            <button
              type="button"
              className="load-more"
              onClick={() =>
                setLoadMorePost(loadMorePost + 1)
              }
            >
              Load More Posts
            </button>
          </div>
        )}
    </>
  );
};

export default PostCardList;
